"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "milena": {
    "aa829e13": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "skipSearch": false
    }],
    "balilla": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "080c3dd7": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "skipSearch": false
    }],
    "cavour": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ed15e145": [{
      "hkey": "aff0b976",
      "slug": "battisti",
      "name": "Battisti",
      "primary": true,
      "skipSearch": false
    }],
    "cesare-battista": [{
      "hkey": "aff0b976",
      "slug": "battisti",
      "name": "Battisti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1fdbf54f": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "skipSearch": false
    }],
    "crispi": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "85414a71": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "skipSearch": false
    }],
    "garibaldi": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d7d26515": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "skipSearch": false
    }],
    "mazzini": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa19a391": [{
      "hkey": "ee546549",
      "slug": "grappa",
      "name": "Grappa",
      "primary": true,
      "skipSearch": false
    }],
    "monte-grappa": [{
      "hkey": "ee546549",
      "slug": "grappa",
      "name": "Grappa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7f5a639d": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "skipSearch": false
    }],
    "piave": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d560b50d": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "skipSearch": false
    }],
    "roma": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d86e772a": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "94f090dc": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "skipSearch": false
    }],
    "san-miceli": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "35f95b2d": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "skipSearch": false
    }],
    "vittorio-veneto": [{
      "hkey": "ea227a32",
      "slug": "milena",
      "name": "Milena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;